import React from 'react';

const Footer = () => (
  <footer className="py-5 px-4 bg-bg_brown text-white w-full">
    <p className="text-center text-xs flex flex-col md:flex-row gap-1 items-center justify-center">
      <span>Copyright © {new Date().getFullYear()},</span>
      <span>Tổng biên tập: Ông Nguyễn Đức Nam - Tộc trưởng Phái 4, Chi 3 đời 19</span>
    </p>
  </footer>
);

export default Footer;
